import { Suspense, lazy } from "react";

// Loaded on demand: the step uses the platform's app parts, which the
// package entry must not import.
const Step = lazy(() => import("./ImportStep").then((m) => ({ default: m.ImportPage })));

/** The Import step used in place of the platform's: media files together
 *  with the CSV or JSON that names them, a check of every task before
 *  saving, zip and folder upload, a sheet to fill in, and duplicates left
 *  out. Same props as the platform's ImportPage. */
export const ImportStepLazy = (props) => (
  <Suspense fallback={null}>
    <Step {...props} />
  </Suspense>
);
